import React, { useState, useRef, useEffect } from 'react';

const ExpandableCell = ({ content }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      const isOverflowing = el.scrollHeight > el.clientHeight;
      setShouldShowButton(isOverflowing);
    }
  }, [content]);

  return (
    <div style={{ maxWidth: "200px" }}>
      <div
        ref={contentRef}
        style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: isExpanded ? "unset" : 3,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          transition: "0.3s all",
        }}
      >
        {content || "-"}
      </div>
      {shouldShowButton && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            color: "#007bff",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "12px",
            marginTop: "4px",
            padding: 0,
            textAlign:"left",
            width:100,
            textDecoration:"underline"
          }}
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default ExpandableCell;
